module.exports = __webpack_public_path__ + "media/images/icons-086fda6bbfdde0de3f0bc435d130f944.png";